import { Component, Input, OnInit } from '@angular/core';
import { CompanyService } from '../../../../services/company.service';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ISection } from '../../models/group-edit-config';

@Component({
  selector: 'app-accrual-group-editor',
  templateUrl: './accrual-group-editor.component.html',
  styleUrls: ['./accrual-group-editor.component.scss']
})
export class AccrualGroupEditorComponent implements OnInit {
    @Input() group: any;
    @Input() set company(c: any){
        this._company = c;
        this.updateValidity();
        console.log("AccrualGroupEditor company is being assigned...");
    }

    _company: any;

    section: ISection;
    form: FormGroup;
    selectedSection: any;
    isValid = false;
    mappingData: any;
    
    constructor(private fb: FormBuilder,
        private comp: CompanyService) { }

        ngOnInit(): void {
            this.form = this.fb.group({});
            const data = this.getAssetGroupMappingData();
            this.mappingData = data;
            this.updateValidity();
    
            this.section = {
                header: '',
                isChild: true,
                allowEdit: false,
                form: this.form,
                items:[
                    {label: this.getFieldLabel(), fieldName: 'mapping', control:'input'},
                ],
                data: data
            };
        }
    
        updateValidity() {
            if(this.mappingData){
                this.isValid = this.mappingData.mapping !== '** MISSING';
            }
        }
    
        getAssetGroupMappingData(): any {
            const data = {
                mapping: this.getAccountName()
            };
            return data;
        }
    
        getAccountName(){
            const purpose = this.getPurpose();
            const item = this.group.mappings.find(x=>x.purpose === purpose);
            if(item){
                return item.nominalAccount;
            }else{
                return '** MISSING';
            }
        }

        getFieldLabel(){
            if(this.group.type === 'AccruedExpense'){
                return "Accrued expenses balance sheet account";
            }else if(this.group.type === 'AccruedIncome'){
                return "Accrued income balance sheet account";
            }else if(this.group.type === 'PrepaidExpense'){
                return "Prepaid expense balance sheet account";
            }else if(this.group.type === 'PrepaidIncome'){
                return "Deferred income balance sheet account";
            }else{
                return "Unknown";
            }
        }

        getFriendlyGroupType(){
            if(this.group.type === 'AccruedExpense'){
                return "Accrued expense";
            }else if(this.group.type === 'AccruedIncome'){
                return "Accrued income";
            }else if(this.group.type === 'PrepaidExpense'){
                return "Prepaid expense";
            }else if(this.group.type === 'PrepaidIncome'){
                return "Deferred income";
            }else{
                return "Unknown";
            }
        }
    
        async editGroup(){
            const result = await this.comp.updateAccrualPrepaymentGroup(this.group.id);
            if(result){
                this.group = result;
                const data = this.getAssetGroupMappingData();
                this.section.data = data;
            }
        }

        getPurpose(){
            if(this.group.type === 'AccruedExpense'){
                return "AccruedExpenseBS";
            }else if(this.group.type === 'AccruedIncome'){
                return "AccruedIncomeBS";
            }else if(this.group.type === 'PrepaidExpense'){
                return "PrepaidExpenseBS";
            }else if(this.group.type === 'PrepaidIncome'){
                return "PrepaidIncomeBS";
            }else{
                return "Unknown";
            }
        }



}
